import Axios, { AxiosError } from 'axios';
import store from '@/store';
import { getError } from '@/plugins/index';

declare module 'axios' {
  export interface AxiosRequestConfig {
    skipErrorMessage?: boolean;
    skipErrorMsgByStatuses?: number[];
    excludeStatuses?: number[];
  }
}

const axios = Axios.create({
  baseURL: (process.env.VUE_APP_HOST ? process.env.VUE_APP_HOST : '') + process.env.VUE_APP_API,
  withCredentials: true,
  headers: {
    'X-Frame-Options': 'SAMEORIGIN',
    'Content-Security-Policy': `script-src "self" ${window.location.origin}`,
    'Permissions-Policy': `geolocation=(self ${window.location.origin})`,
    'X-Content-Type-Options': 'nosniff',
    'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
  },
});

// if (process.env.VUE_APP_MOCK === 'true') {
//
// }

interface ApiResponseError {
  errorMessage?: string;
  message?: string;
  [key: string]: any;
}

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (e: AxiosError) {
    if (
      e.response?.status === 401 &&
      store.getters.authorized === 'authorized' &&
      !/user\/info\/$/.test(e.request.responseURL)
    ) {
      if (store.getters.loader.show) {
        store.dispatch('setLoader');
        console.log('Лоадер закрылся при 401');
      }
      store.commit('setSession');
    } else if (e.response?.status === 423) {
      //@ts-ignore
      if (e.response.data.errorMessage === 'Role block ') {
        store.commit('setAccessRole');
      } else if (window.location.pathname !== '/login') {
        store.commit('setAccessUser');
      }
    }

    let errorData: ApiResponseError = {};
    const isFormDataRequest = e.config?.data instanceof FormData;
    if (isFormDataRequest && e.response?.data) {
      try {
        // Если это Blob
        if (e.response.data instanceof Blob) {
          const blobData: Blob = e.response.data;
          const contentType = e.response.headers?.['content-type'] || '';

          if (contentType.includes('application/json') || contentType.includes('text/')) {
            const text = await blobData.text();
            try {
              errorData = JSON.parse(text);
            } catch {
              errorData = { message: text || 'Ошибка загрузки файла' };
            }
          } else {
            errorData = { message: 'Ошибка при обработке файла на сервере' };
          }
          e.response.data = errorData;
        }
        // Если это строка (текстовый ответ)
        else if (typeof e.response.data === 'string') {
          try {
            errorData = JSON.parse(e.response.data);
          } catch {
            errorData = { message: e.response.data || 'Ошибка загрузки файла' };
          }
          e.response.data = errorData;
        }
        // Если это уже объект, просто добавляем флаг
        else if (typeof e.response.data === 'object') {
          errorData = e.response.data;
        }
      } catch (formDataError) {
        console.error('Ошибка обработки FormData response:', formDataError);
        errorData = { message: 'Ошибка обработки ответа сервера' };
        e.response.data = errorData;
      }
    } else if (e.response?.data && e.response.config.responseType === 'blob' && e.response.data instanceof Blob) {
      const blobData: Blob = e.response.data;
      const text = await blobData.text();
      errorData = JSON.parse(text);
      e.response.data = errorData;
    }

    if (e.config?.skipErrorMessage || e?.response?.status && e.config?.skipErrorMsgByStatuses?.includes(e.response.status))
      return Promise.reject(e);

    if (e.response?.status && [409, 404, 400].includes(e.response.status) && !e.config?.excludeStatuses?.includes(e.response.status)) {
      // console.log(123, e);
      const message = getError(e.response);
      if (!message){
        store.dispatch('setError', e);
      }
      else {
        store.dispatch('addSuccess', {
          message,
          color: 'error',
          manual: true,
        });
      }
    } else {
      store.dispatch('setError', e);
    }

    return Promise.reject(e);
  },
);

export { axios };
